module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/94b50a9a2e8d095fd731e01b5f88b3f4.png";